import Vue from 'vue'
import Vuex from 'vuex'
import router from '../router'
import constants from './constants'
import brandLogosDictionary from './brandLogosDictionary'

Vue.use(Vuex)

const state = {

  // Product Options configs
  selectedPrimaryOption: undefined,
  selectedSecondaryOption: undefined,
  childOptionsForPrimaryOption: undefined,
  primaryProductId: undefined,
  secondaryProductId: undefined,

  // Player-state configs
  environment: '',
  currentPlayerId: undefined,
  currentPlayer: undefined,
  currentPlayerType: undefined,
  currentPlayerProducts: [],
  currentPlayerVideos: [],

  // Cart-state configs
  cart:[],
  currentMulticartRetailer: undefined,
  currentRetailerCart: undefined,
  checkoutUrl: undefined,
  shopifyUrl: undefined,
  checkoutInProgress: undefined,

  // DOM globals
  videoWrapperId: 'video-element-wrapper',
  videoElementId: 'video-player-element',

  // Gallery view config for uploading sample demo video.
  galleryVideoOverride: undefined,

  brandLogosDictionary: brandLogosDictionary,

  // State configs
  showMultiCardAddOptions: false,
  productsLockedToVideos: false,
  currentVideoCanPlay: undefined,
  currentVideoIndex: 0,
  currentProductIndex: 0,
  currentFocusedProduct: undefined,
  loopVideos: false,
  muted: true,
  infoBoxVisible: false,
  focusedProductImage: undefined,
  checkoutButtonActive: false,
  constants: constants,
  currentVideo: undefined,
  currentPlayerLanguage: undefined,
  currentBrand: undefined,
  storePlayerTouched: undefined,
  emailModalShowing: false,
  emailModalHasAppeared: false,
  forceShowEmailModal: false,
  totalRatingsSubmitted: 0,
  ratePlayerInfiniteMode: false,
  rateCtaIndex: 0,
  showOptions: false,
  addedToCartState: false,
  showInternetExplorerWarning: false,
  showDisclaimerText: false,
}

const mutations = {
  toggleDisclaimerText(state, toggle) {
    state.showDisclaimerText = toggle
  },
  markCheckoutAsInProgress() {
    state.checkoutInProgress = true
  },
  updateGalleryVideoOverride(state, videoUrl) {
    state.galleryVideoOverride = videoUrl
  },
  setCurrentMulticartRetailer(state, cart) {
    state.currentMulticartRetailer = cart
  },
  updateCurrentVideoCanPlay(state, canPlay) {
    state.currentVideoCanPlay = canPlay
  },
  setCurrentRetailerCart(state, cart) {
    state.currentRetailerCart = cart
  },
  setCheckoutUrl(state, url) {
    state.checkoutUrl = url
  },
  setShopifyUrl(state, url) {
    state.shopifyUrl = url
  },
  incrementCurrentVideoIndex() {
    let currentIndex = state.currentVideoIndex
    currentIndex++

    if (currentIndex > state.currentPlayerVideos.length - 1) currentIndex = 0

    updateVideoDetails(currentIndex)
  },
  decrementCurrentVideoIndex() {
    let currentIndex = state.currentVideoIndex
    currentIndex--

    if (currentIndex < 0) currentIndex = state.currentPlayerVideos.length - 1

    updateVideoDetails(currentIndex)
  },
  updateLoopVideoSettings(state, loopVideos) {
    state.loopVideos = loopVideos
  },
  setMute(state, muted) {
    state.muted = muted
  },
  toggleMute()  {
    state.muted = !state.muted
  },
  toggleMultiCardAddOptions(state, showOptions) {
    state.showMultiCardAddOptions = showOptions
  },
  setInfoBoxVisible(state, isVisible) {
    state.infoBoxVisible = isVisible
  },
  setFocusedProductImage(state, image) {
    state.focusedProductImage = image
  },
  setCheckoutButton(state, active) {
    state.checkoutButtonActive = active
  },
  setCurrentPlayer(state, player) {
    state.currentPlayer = player
    state.currentPlayerVideos = player.videos
    state.currentPlayerType = player.playerType
    state.currentPlayerLanguage = player.language

    if (player.products) {
      state.currentPlayerProducts = player.products
    } else {
      state.currentPlayerProducts = player.videos
    }

    if (player.videos && player.videos[0]) {
      state.currentVideo = player.videos[0]
    }

    state.currentFocusedProduct = state.currentPlayerProducts[state.currentProductIndex]
    state.addedToCartState = false

    if (state.currentPlayerType == 'standard' && state.currentPlayerProducts.length > 1) {
      state.productsLockedToVideos = true
    }

  },
  setCurrentFocusedProduct(state, product) {
    state.currentFocusedProduct = product
  },
  setCurrentPlayerId(state, id) {
    state.currentPlayerId = id
  },
  setCurrentEnvironment(state, environment) {
    state.environment = environment
  },
  forceShowEmailModal(state, show) {
    state.forceShowEmailModal = show
  },
  incrementTotalRatingsSubmitted() {
    state.totalRatingsSubmitted++
  },
  setCurrentProductIndex(state, index) {
    state.currentProductIndex = index
    state.currentFocusedProduct = state.currentPlayerProducts[state.currentProductIndex]
    state.addedToCartState = false
  },
  updateProduct(state, productData) {
    let index = productData.index
    let product = productData.product
    state.currentPlayer.products[index] = product
    state.currentPlayerProducts[index] = product
    state.currentFocusedProduct = state.currentPlayerProducts[state.currentProductIndex]
  },
  expandStorePlayerCards() {
    state.storePlayerTouched = true
  },
  collapseStorePlayerCards() {
    state.storePlayerTouched = false
  },
  toggleEmailModal(state, visible) {
    state.emailModalShowing = visible
    if (visible) state.emailModalHasAppeared = true
  },
  updateRateCtaIndex(state, integer) {
    state.rateCtaIndex = integer
  },
  setCurrentBrand(state, brand) {
    state.currentBrand = brand
  },
  addItemToCart(state, item) {
    state.cart.push(item)
  },
  setSelectedPrimaryOption(state, opt) {
    state.selectedPrimaryOption = opt
  },
  setPrimaryProductId(state, id) {
    state.primaryProductId = id
  },
  setSecondaryProductId(state, id) {
    state.secondaryProductId = id
  },
  setChildOptionsForPrimaryOption(state, optionArray) {
    state.childOptionsForPrimaryOption = optionArray
  },
  setSelectedSecondaryOption(state, opt) {
    state.selectedSecondaryOption = opt
  },
  setShowOptions(state, isVisible) {
    state.showOptions = isVisible
  },
  setAddedToCartState(state, isVisible) {
    state.addedToCartState = isVisible
  },
  hideInternetExplorerWarning() {
    state.showInternetExplorerWarning = false
  },
  revealInternetExplorerWarning() {
    state.showInternetExplorerWarning = true
  }
}

const updateVideoDetails = (currentIndex) => {
  state.checkoutButtonActive = false
  state.currentVideoIndex = currentIndex
  state.currentVideo = state.currentPlayerVideos[state.currentVideoIndex]
  if (state.productsLockedToVideos) {
    state.currentProductIndex = currentIndex
    state.currentFocusedProduct = state.currentPlayerProducts[state.currentProductIndex]
    state.addedToCartState = false
  }
}

const store = new Vuex.Store({
  state,
  mutations
})

export default store



// WEBPACK FOOTER //
// ./client/store/index.js